import createRouter from './create-router';
export const router = createRouter();


